import { Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AuthService } from '@auth/auth.service';
import * as authActions from '@auth/store/auth.actions';
import { DataService } from '@data/data.service';

import * as gridColumnDefinitions from '../change-facility-grid/change-facility-grid.columns';

@Component({
  selector: 'app-change-facility-screen',
  templateUrl: './change-facility-screen.component.html',
  styleUrls: ['./change-facility-screen.component.scss'],
})
export class ChangeFacilityScreenComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  private prevScreenOffset: number;

  public showGrid = false;
  public selectedRow: any = null;

  public menuList = [
    { action: () => this.dismissDialog(), icon: 'cancel', title: 'Close' },
    { action: () => this.authService.changeFacilityShowing.next('filter'), icon: 'filter_alt' },
    { action: () => this.selectRow(), icon: 'check_box', title: 'Select', condition: () => !!this.selectedRow },
    { action: () => this.authService.changeFacilityShowing.next('help'), icon: 'help_outline', title: 'Help' },
  ];

  public helpList = [
    { icon: 'cancel', title: 'Dismiss Dialog' },
    { icon: 'filter_alt', title: 'Filter' },
    { icon: 'check_box', title: 'Select Facility' },
  ];

  public columns = gridColumnDefinitions;
  public changeScreen = (area) => this.authService.changeFacilityShowing.next(area);
  public showMain = () => this.authService.changeFacilityShowing.next('grid');

  constructor(public authService: AuthService, private store: Store, public dataService: DataService) {}

  ngOnInit() {
    this.authService.selectedFacilityRow$.pipe(takeUntil(this.destroy$)).subscribe((row) => (this.selectedRow = row));

    this.authService.changeFacilityDialog$
      .pipe(
        filter((x) => !!x),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.init());

    this.authService.changeFacilityDismissDialog.next(false);
    this.authService.changeFacilityDismissDialog.pipe(takeUntil(this.destroy$)).subscribe((x) => {
      if (x) {
        this.dismissDialog();
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  init() {
    this.prevScreenOffset = this.dataService.screenOffset;
    this.authService.selectedFacilityRow$.next(null);
    this.dataService.hideScreen$.next(true);

    this.showGrid = false;
    setTimeout(() => (this.showGrid = true), 50);
  }

  dismissDialog() {
    this.dataService.wsScreenAdjust.next(this.prevScreenOffset);
    this.dataService.hideScreen$.next(false);
    this.authService.changeFacilityDialog$.next(false);
    this.authService.changeFacilityDismissDialog.next(false);
  }

  selectRow() {
    if (this.selectedRow) {
      this.authService.changeCustomerOrFacilityPending$.next(true);
      this.store.dispatch(new authActions.ChangeFacility(this.selectedRow.key));
      this.dismissDialog();
    }
  }
}
